import React, { useState } from 'react';
import { Formik, Form } from 'formik'
import { Typography } from '@material-ui/core'
import CustomTextField from '../forgot-password/CustomTextField'
import CustomButton from '../forgot-password/CustomButton'
import { Alert } from '@material-ui/lab';

export default function ForgotPasswordForm({ email, onSubmit, onSuccess, onFailure }) {
  const [success,setSuccess] = useState(false)
  return <div>
    <Typography variant="h5" align="center" style={{ textAlign: 'center', margin: '24px 0 32px 0'}}>
      Mot de passe oublié ?
    </Typography>
    <Formik
      initialValues={{
        email,
      }}
      validate={(values) => {
        const errors = {}

        if (!values.email) {
          errors.email = 'Votre email est nécessaire'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
          errors.email = 'Email Incorrect'
        }

        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true)
        onSubmit(values)
          .then((data) => {
            setSubmitting(false);
            onSuccess(values);
            setSuccess(true);
          })
          .catch((error) => {
            setSubmitting(false);
            onFailure(error);
          });
      }}
    >
      {({ values, submitForm, isSubmitting }) => (
        <Form>
          <Typography style={{
            marginBottom: 16,
          }}>
            Saisissez l'adresse e-mail associée à votre compte.
            Nous vous enverrons un lien par e-mail pour réinitialiser votre mot de passe.
          </Typography> 
          {success && <Alert severity="success">
            {`Un lien pour réinitialiser votre mot de passe a été envoyé par e-mail à ${values.email}`}
          </Alert>}
          <CustomTextField
            name="email"
            placeholder="Adresse e-mail"
            type="email"
            required
            style={{ marginBottom: 16 }}
          /> 
          <CustomButton
            color="secondary"
            onClick={submitForm}
            disabled={isSubmitting}
          >
            Envoyer le lien de réinitialisation
          </CustomButton>
        </Form>
      )}
    </Formik>
  </div>;
}
